import { styled } from '@linaria/react';

export const RowLayout = styled.div<{
  numberOfCells: number;
}>`
  display: grid;
  grid-template-columns: repeat(${props => props.numberOfCells}, var(--ogm-grid-column-width));
  grid-column-gap: var(--ogm-grid-cell-gap);
  width: 100%;

  @media (min-width: 768px) and (max-width: 1257px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      grid-template-columns: repeat(${props => props.numberOfCells + 1}, var(--ogm-grid-column-width));
    }
  }
`;

export const MarginTablet = styled.div`
  display: none;

  @media (min-width: 768px) and (max-width: 1257px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: inline-block;
      min-width: 22px;
      max-width: 22px;
      height: 100%;
    }
  }
`;
